import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import { TriggerService } from '../../core/trigger/trigger_service';
import { WFormsTableWrapper } from '../../core/table/WFormsTableWrapper';

export interface DateneingabeSicherheitszuschlageProps {
    standortSelected: any;
}

export interface DateneingabeSicherheitszuschlageState {
    dummy?: any;
}

export class DateneingabeSicherheitszuschlage extends
    React.Component<DateneingabeSicherheitszuschlageProps, DateneingabeSicherheitszuschlageState> {

    constructor(props: any) {
        super(props);
        this.state = {};
        this.preFilter = this.preFilter.bind(this);
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    preFilter (data: Array<any>): Array<any> {
        const { standortSelected } = this.props;

        return standortSelected
            ? data
                .filter((item: any) => (
                    item.standort_tid_orig
                    && +item.standort_tid_orig === standortSelected.tid
                ))
            : data;
    }

    render(): JSX.Element {
        return (
            <div>
                <WFormsTableWrapper
                    entity={IDs.ENT_CO2_SICHERHEITSZUSCHLAG}
                    module={IDs.MOD_ETOOL}
                    actions={['add', 'edit', 'delete']}
                    customClass={'Custom-ETA'}
                    formLayout={'flowV2'}
                    preFilterFunction={this.preFilter}
                    onSaveDone={() => this.triggerService.fire('reload', IDs.ENT_KLIMAGASE)}
                />
            </div>
        );
    }
}
